import PageMeta from "components/components/Meta/PageMeta";
import AdditionalInfoSection from "components/dataVisualization/dataPageComponents/AdditionalInfoSection/AdditionalInfoSection";
import PageHeader from "components/dataVisualization/dataPageComponents/PageHeader/PageHeader";
import RestorationZoneDemandRestoredContainer from "components/dataVisualization/restorationZone/DemandRestored/RestorationZoneDemandRestoredContainer/RestorationZoneDemandRestoredContainer";
import RestorationZoneDemandRestoredSummaryTile from "components/dataVisualization/restorationZone/DemandRestored/RestorationZoneDemandRestoredSummaryTile/RestorationZoneDemandRestoredSummaryTile";
import { ChartFocussedDateProvider } from "contexts/ChartFocussedDateContext";
import React from "react";

const RestorationZoneDemandRestored: React.FC = () => (
  <ChartFocussedDateProvider>
    <>
      <PageMeta title="Restoration region demand restored" />
      <PageHeader
        title="Restoration region demand restored"
        pageDescription={
          <p>
            During a system restoration event National Energy System Operator
            (NESO) provides hourly updates to enable tracking of restoration
            progress in a specific restoration region. <br />
            <br />
            60% of demand in each restoration region must be restored within 24
            hours.
            <br />
            100% of national demand must be restored within 5 days.
          </p>
        }
        expanderHeading="What you need to know while using this data"
        expanderContent={
          <>
            <p>
              There are 7 regions, these are used to plan and monitor the
              restoration of power in the event of a major outage.
            </p>
            <ul>
              <li>South East</li>
              <li>South West</li>
              <li>Midlands</li>
              <li>North East</li>
              <li>North West</li>
              <li>North Scotland</li>
              <li>South Scotland</li>
            </ul>
            <p>Note: GSP Group ID will be included when provided by NESO.</p>
          </>
        }
      >
        <RestorationZoneDemandRestoredSummaryTile />
      </PageHeader>
      <RestorationZoneDemandRestoredContainer />
      <AdditionalInfoSection
        documentationInformation={{
          chart: ["datasets/RZDR"],
          tile: ["demand/by-restoration-zone/restored/submissions"],
        }}
      />
    </>
  </ChartFocussedDateProvider>
);

export default RestorationZoneDemandRestored;
